import React from 'react';
import SelfActionButtons from './SelfActionButtons/SelfActionButtons';

const NewDalpakItemsBlock = (props) => {
  return <SelfActionButtons {...props} />;
};

export default NewDalpakItemsBlock;
